import ServicePageLayout from "@/pages/services/components/ServicePageLayout";

const relatedServices = [
  { label: "Toitures-terrasses", href: "/services/toitures-terrasses" },
  { label: "Dalles carrossables", href: "/services/dalles-carrossables" },
  { label: "Terrasses", href: "/services/terrasses" },
  { label: "Étanchéité + isolation thermique", href: "/services/etancheite-isolation" },
];

export default function ParkingsPage() {
  return (
    <ServicePageLayout
      tag="Enrobés & asphalte"
      title="Parkings"
      subtitle="Étanchéité et revêtement de parkings en sous-sol, en surface ou en superstructure — enrobé coulé à froid, asphalte gravillonné, résines époxy."
      heroImage="https://readdy.ai/api/search-image?query=modern%20underground%20parking%20garage%20with%20smooth%20freshly%20applied%20dark%20grey%20epoxy%20resin%20floor%20coating%2C%20bright%20LED%20lighting%20reflecting%20on%20glossy%20surface%2C%20clean%20geometric%20lines%2C%20professional%20industrial%20photography%2C%20impressive%20scale%2C%20wide%20angle%20view&width=1440&height=900&seq=ksbtp-park-hero-001&orientation=landscape"
      heroAlt="Étanchéité parking KS BTP"
      intro="L'étanchéité des parkings est un enjeu majeur pour la durabilité des ouvrages. KS BTP maîtrise l'ensemble des techniques adaptées aux parkings en sous-sol, en superstructure ou en surface : enrobé coulé à froid, asphalte gravillonné, résines époxy et membranes sous chape. Nous intervenons aussi bien en neuf qu'en réfection, avec une attention particulière aux joints de dilatation et aux relevés d'étanchéité."
      techItems={[
        { icon: "ri-road-map-line", label: "Enrobé coulé à froid" },
        { icon: "ri-building-line", label: "Asphalte gravillonné" },
        { icon: "ri-drop-fill", label: "Résines époxy" },
        { icon: "ri-layout-grid-line", label: "Membranes sous chape" },
        { icon: "ri-arrow-left-right-line", label: "Joints de dilatation" },
        { icon: "ri-tools-line", label: "Réfection & rénovation" },
      ]}
      steps={[
        {
          number: "01",
          title: "Étude du support",
          description: "Analyse de l'état du béton, des fissures, des joints et des zones de rétention d'eau.",
        },
        {
          number: "02",
          title: "Préparation",
          description: "Grenaillage, ragréage et traitement des fissures pour garantir l'adhérence du système d'étanchéité.",
        },
        {
          number: "03",
          title: "Application",
          description: "Mise en œuvre du système choisi (asphalte, résine, membrane) par nos équipes spécialisées.",
        },
        {
          number: "04",
          title: "Finitions & contrôle",
          description: "Marquage au sol, signalétique, test d'étanchéité et remise du dossier de garantie.",
        },
      ]}
      advantages={[
        "Expertise sur tous types de parkings : sous-sol, superstructure, surface",
        "Systèmes adaptés aux charges lourdes et au trafic intense",
        "Traitement des joints de dilatation et des relevés",
        "Matériaux certifiés et conformes aux normes en vigueur",
        "Intervention en site occupé possible, planning adapté",
        "Garantie décennale et suivi post-chantier",
      ]}
      galleryImages={[
        {
          src: "https://readdy.ai/api/search-image?query=workers%20applying%20liquid%20epoxy%20resin%20coating%20on%20underground%20parking%20floor%2C%20professional%20team%2C%20industrial%20equipment%2C%20bright%20lighting%2C%20smooth%20grey%20surface%20being%20treated%2C%20construction%20photography&width=600&height=440&seq=ksbtp-park-gal-001&orientation=landscape",
          alt: "Application résine époxy parking",
        },
        {
          src: "https://readdy.ai/api/search-image?query=finished%20underground%20parking%20with%20glossy%20epoxy%20floor%2C%20white%20painted%20columns%2C%20clear%20lane%20markings%2C%20bright%20LED%20lights%2C%20modern%20clean%20aesthetic%2C%20professional%20photography&width=600&height=440&seq=ksbtp-park-gal-002&orientation=landscape",
          alt: "Parking terminé résine époxy",
        },
        {
          src: "https://readdy.ai/api/search-image?query=close%20up%20of%20asphalt%20waterproofing%20layer%20being%20applied%20on%20parking%20deck%2C%20dark%20bituminous%20material%2C%20professional%20roofer%20with%20tools%2C%20construction%20site%2C%20sharp%20detail&width=600&height=440&seq=ksbtp-park-gal-003&orientation=landscape",
          alt: "Asphalte gravillonné parking",
        },
      ]}
      relatedServices={relatedServices}
    />
  );
}
